import { render } from "./TicketAddTag.vue?vue&type=template&id=6940f366&ts=true"
import script from "./TicketAddTag.vue?vue&type=script&lang=ts"
export * from "./TicketAddTag.vue?vue&type=script&lang=ts"

import "./TicketAddTag.vue?vue&type=style&index=0&id=6940f366&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__